import React from 'react';
import _get from 'lodash/get';
import { KeyValueView } from 'commons-ui';

import useUserProfileActions from '../../useUserProfileActions';
import { getKeyConfig } from './keyConfig';
import { makeActionList, makeActionHandler } from './actions';
import { VIEW_FIELD_KEYS } from './constants';

interface TransactionDetailsProps {
	transactionAllDetails: any;
}
const TransactionDetails: React.FC<TransactionDetailsProps> = (props) => {
	const { transactionAllDetails } = props;
	const { keyConfig, keyValueLayout } = getKeyConfig(transactionAllDetails);
	const { getActionHandler, getActionList } = useUserProfileActions(makeActionHandler, makeActionList, {
		transactionAllDetails,
		tid: _get(transactionAllDetails, 'transactionId'),
		[VIEW_FIELD_KEYS.TRANSACTION_TYPE]: _get(transactionAllDetails, VIEW_FIELD_KEYS.TRANSACTION_TYPE)
	});

	return (
		<KeyValueView
			keyConfig={keyConfig}
			keyValueLayout={keyValueLayout}
			getActionHandler={getActionHandler}
			getActionList={getActionList}
		/>
	);
};

export default TransactionDetails;
